<div class="header-container">
  <div class="header-title-block">
    <button *ngIf="backLink" (click)="navigateBack()" mat-icon-button>
      <mat-icon>arrow_back</mat-icon>
    </button>
    <ng-content select="wz-page-title"></ng-content>
  </div>
  <ng-content></ng-content>
</div>
